import { h } from "@stencil/core";
export const createContext = (defaultValue) => {
    const Provider = (props, children) => {
        let resolvedValue = (props && props.value) || defaultValue;
        return (h("stencil-provider", { STENCIL_CONTEXT: resolvedValue }, children));
    };
    const Consumer = (props, children) => {
        if (!children.length) {
            return console.warn('[stencil-context] You must pass <Consumer> a single child that is a Function.');
        }
        const renderer = children[0];
        if (!(renderer instanceof Function)) {
            return console.warn('[stencil-context] <Consumer> first child must be a Function.');
        }
        return h("stencil-consumer", { renderer: renderer });
    };
    return {
        Provider,
        Consumer,
    };
};
